import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import HomePage from "./components/HomePage";
import QuizLoader from "./components/QuizLoader";

export default function App() {
  return (
    <BrowserRouter>
      <Navbar />

      <div className="container-fluid mt-4">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/exam" element={<QuizLoader />} />
        </Routes>
      </div>

      <Footer />
    </BrowserRouter>
  );
}
